import COS from 'cos-js-sdk-v5';
import { requestWrapper } from '@/util/util';
import tencentCloud from '@/api/basic/tencent-cloud';

async function uploadFiles(files, onProgress, onFileFinish) {
  const signResponse = await requestWrapper(tencentCloud.getCosSign);
  if (!signResponse || signResponse.ok === false || signResponse.code !== 0) {
    throw new Error('获取签名失败');
  }

  const cos = new COS({
    getAuthorization(options, callback) {
      callback({
        TmpSecretId: signResponse.data.accessKeyId,
        TmpSecretKey: signResponse.data.policy,
        XCosSecurityToken: signResponse.data.signature,
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: signResponse.data.startTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: signResponse.data.expiredTime, // 时间戳，单位秒，如：1580000900
      });
    },
  });

  return new Promise((resolve, reject) => {
    const uploadFiles = files.map((item) => ({
      Bucket: signResponse.data.bucket,
      Region: signResponse.data.region,
      Key: item.key,
      Body: item.file,
    }));
    cos.uploadFiles({
      files: uploadFiles,
      SliceSize: 1024 * 1024,
      onProgress(info) {
        const percent = Math.floor(info.percent * 10000) / 100;
        const speed = Math.floor((info.speed / 1024 / 1024) * 100) / 100;
        console.log(`进度：${percent}%; 速度：${speed}Mb/s;`);
        if (typeof onProgress === 'function') {
          onProgress(percent, speed);
        }
      },
      onFileFinish(err, data, options) {
        console.log(`${options.Key} 上传${err ? '失败' : '完成'}`);
        if (typeof onFileFinish === 'function') {
          data.host = signResponse.data.cdnHost || signResponse.data.host;
          onFileFinish(err, data, options);
        }
      },
    }, (err, data) => {
      if (err) {
        console.log('\x1B[31m上传失败\x1B[0m');
        console.log(err);
        reject(err);
        return;
      }

      const errors = data.files.filter((item) => item.error !== null);
      if (errors && errors.length > 0) {
        console.log(errors);
        console.log('\x1B[31m上传失败\x1B[0m');
        reject(errors);
        return;
      }

      console.log('\x1B[32m上传成功\x1B[0m');
      resolve(files.map((item) => ({
        ...item,
        fileUrl: `${signResponse.data.cdnHost || signResponse.data.host}/${item.key}`,
      })));
    });
  });
}

export default {
  uploadFiles,
};
